export default "__VITE_ASSET__756791ed__"